<template>
    <div class="text-justify" style="font-size: 12px; line-height: 150%">
        <h4>DEFINISI</h4>
        <p>
            Kecuali secara tegas ditentukan lain dalam Syarat dan Ketentuan ini,
            istilah-istilah berikut memiliki arti sebagai berikut:
        </p>
        <ul>
            <li>
                "Aplikasi {{ VUE_ENV.VUE_APP_NAME }}": platform digital milik
                dan dikelola oleh {{ VUE_ENV.VUE_APP_COMPANY_NAME }} ({{
                    VUE_ENV.VUE_APP_NAME
                }}) yang menyediakan berbagai layanan transaksi digital termasuk
                layanan QRIS.
            </li>
            <li>
                "Pengguna": individu atau badan usaha yang telah terdaftar dan
                melakukan verifikasi pada Aplikasi
                {{ VUE_ENV.VUE_APP_NAME }} serta menggunakan layanan QRIS.
            </li>
            <li>
                "Layanan QRIS": bisa disebut juga QRIS Merchant adalah layanan
                pembayaran berbasis kode QR (Quick Response Code Indonesian
                Standard) yang tersedia di Aplikasi {{ VUE_ENV.VUE_APP_NAME }}.
            </li>
            <li>
                "Penerbit QRIS": pihak ketiga penyedia layanan QRIS yang telah
                memiliki izin resmi dari Bank Indonesia dan bekerja sama dengan
                {{ VUE_ENV.VUE_APP_NAME }}.
            </li>
            <li>
                "Settlement": proses penyelesaian transaksi, yaitu pengiriman
                dana hasil transaksi QRIS ke saldo akun
                {{ VUE_ENV.VUE_APP_NAME }} milik Pengguna.
            </li>
            <li>
                "Fast Settlement": layanan percepatan penyelesaian transaksi
                yang memungkinkan dana langsung masuk ke saldo Pengguna dengan
                dikenakan biaya tertentu.
            </li>
            <li>
                "MDR (Merchant Discount Rate)": potongan biaya yang dikenakan
                atas transaksi QRIS sesuai dengan ketentuan Penerbit dan
                regulasi Bank Indonesia.
            </li>
        </ul>
        <h4>KETENTUAN UMUM</h4>
        <p>
            Dengan menggunakan layanan QRIS di Aplikasi
            {{ VUE_ENV.VUE_APP_NAME }}, Pengguna dianggap telah membaca,
            memahami, dan menyetujui seluruh Syarat dan Ketentuan ini.
        </p>
        <h4>PERSYARATAN PENGGUNAAN QRIS</h4>
        <p>3.1. Layanan QRIS hanya tersedia bagi Pengguna yang telah:</p>
        <ul>
            <li>
                Melakukan verifikasi identitas pribadi (e-KTP, selfie, dan/atau
                verifikasi biometrik);
            </li>
            <li>
                Mengisi dan melengkapi data usaha yang valid dan dapat
                diverifikasi;
            </li>
            <li>
                Menyatakan kesediaan mengikuti ketentuan yang ditetapkan oleh
                {{ VUE_ENV.VUE_APP_NAME }} dan Penerbit QRIS.
            </li>
        </ul>
        <p>
            3.2. {{ VUE_ENV.VUE_APP_NAME }} berhak menolak permohonan akses
            layanan QRIS tanpa kewajiban memberikan alasan.
        </p>
        <h4>PENYELENGGARA LAYANAN QRIS</h4>
        <p>
            4.1. {{ VUE_ENV.VUE_APP_NAME }} tidak menerbitkan QRIS secara
            langsung, namun bekerja sama dengan pihak Penerbit QRIS yang
            memiliki izin resmi dari Bank Indonesia.
        </p>
        <p>
            4.2. Segala bentuk teknis penerbitan, pengelolaan, dan kepatuhan
            terhadap regulasi Bank Indonesia menjadi tanggung jawab Penerbit
            QRIS.
        </p>
        <h4>PROSES SETTLEMENT TRANSAKSI</h4>
        <p>
            5.1. Pengguna memahami bahwa Dana hasil transaksi QRIS akan
            dikirimkan ke saldo akun {{ VUE_ENV.VUE_APP_NAME }} milik Pengguna.
        </p>
        <p>
            5.2. Waktu penyelesaian settlement mengikuti ketentuan dari Penerbit
            QRIS dan peraturan dari Bank Indonesia.
        </p>
        <p>
            5.3. Pengguna dapat memilih fitur Fast Settlement untuk mempercepat
            proses pengiriman dana ke saldo akun dengan biaya tambahan yang
            ditentukan oleh {{ VUE_ENV.VUE_APP_NAME }}.
        </p>
        <h4>BIAYA TRANSAKSI DAN MDR</h4>
        <p>
            6.1. Biaya MDR dikenakan atas setiap transaksi QRIS dan mengikuti
            ketentuan dari masing-masing Penerbit QRIS.
        </p>
        <p>
            6.2. {{ VUE_ENV.VUE_APP_NAME }} tidak bertanggung jawab atas
            perubahan kebijakan biaya MDR yang dilakukan oleh Penerbit, namun
            akan memberitahukan Pengguna apabila terdapat perubahan signifikan.
        </p>
        <h4>LARANGAN PENGGUNAAN QRIS</h4>
        <p>Pengguna dilarang menggunakan layanan QRIS untuk transaksi:</p>
        <ul>
            <li>
                Terkait dengan pencucian uang, pendanaan terorisme, dan/atau
                tindakan melawan hukum lainnya;
            </li>
            <li>Penjualan barang ilegal, palsu, atau bajakan;</li>
            <li>Transaksi perjudian;</li>
            <li>
                Transaksi eksploitasi anak, pornografi, perdagangan manusia,
                atau perdagangan organ manusia;
            </li>
            <li>Penipuan, penyalahgunaan data, manipulasi identitas;</li>
            <li>Aktivitas yang melanggar hukum atau peraturan yang berlaku.</li>
        </ul>
        <p>
            Pelanggaran terhadap ketentuan ini dapat mengakibatkan pemblokiran
            layanan, pelaporan kepada pihak berwajib, dan/atau tuntutan hukum.
        </p>
        <h4>KENDALA DAN PENANGANAN MASALAH</h4>
        <p>8.1. Apabila terjadi kendala seperti:</p>
        <ul>
            <li>
                Transaksi telah berhasil di aplikasi pembeli tetapi belum
                tercatat pada sistem {{ VUE_ENV.VUE_APP_NAME }};
            </li>
            <li>Dana belum diterima dalam waktu wajar;</li>
        </ul>
        <p>
            Maka Pengguna wajib melaporkan melalui layanan bantuan
            {{ VUE_ENV.VUE_APP_NAME }}.
        </p>
        <p>
            8.2. {{ VUE_ENV.VUE_APP_NAME }} akan melakukan investigasi dan
            bekerja sama dengan Penerbit QRIS untuk menyelesaikan permasalahan
            tersebut dalam waktu maksimal 5 (lima) Hari Kerja.
        </p>
        <p>
            8.3. Dalam hal terjadi perselisihan,
            {{ VUE_ENV.VUE_APP_NAME }} berhak meminta bukti transaksi dari
            Pengguna.
        </p>
        <h4>KEADAAN KAHAR (FORCE MAJEURE)</h4>
        <p>
            {{ VUE_ENV.VUE_APP_NAME }} tidak bertanggung jawab atas
            keterlambatan atau kegagalan layanan QRIS akibat keadaan di luar
            kendali wajar, termasuk namun tidak terbatas pada gangguan sistem,
            kebijakan pemerintah, bencana alam, gangguan listrik, dan
            sebagainya.
        </p>
        <h4>PRIVASI DAN KEAMANAN DATA</h4>
        <p>
            10.1. Seluruh data yang dikumpulkan sehubungan dengan layanan QRIS
            akan dijaga kerahasiaannya sesuai dengan peraturan
            perundang-undangan yang berlaku.
        </p>
        <p>
            10.2. Data dapat dibagikan kepada Penerbit QRIS hanya untuk
            keperluan verifikasi dan pelaksanaan layanan.
        </p>
        <h4>PERUBAHAN KETENTUAN</h4>
        <p>
            {{ VUE_ENV.VUE_APP_NAME }} berhak melakukan perubahan terhadap
            Syarat dan Ketentuan ini dengan pemberitahuan sebelumnya melalui
            aplikasi atau media lain.
        </p>
        <h4>PENYELESAIAN SENGKETA</h4>
        <p>
            Sengketa antara Pengguna dan {{ VUE_ENV.VUE_APP_NAME }} terkait
            layanan QRIS akan diselesaikan secara musyawarah. Apabila tidak
            tercapai, akan diselesaikan melalui Pengadilan Negeri tempat
            kedudukan hukum {{ VUE_ENV.VUE_APP_NAME }}.
        </p>
        <h4>PENUTUP</h4>
        <p>
            Dengan menggunakan layanan QRIS, Pengguna menyatakan tunduk dan
            terikat pada seluruh isi Syarat dan Ketentuan ini.
        </p>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    export default {
        name: 'term-of-service',
        computed: {
            ...mapState(['VUE_ENV']),
        },
    };
</script>
